import { IRecommendedPackageService } from '../../../../types/reducers/recommendedPackages';
import { TPayPackageService } from '../../../../../PayPackageMicrofrontend';
import { getIcon } from './getIcon';
import { getServiceName } from './getServiceName';

export const mapService = (service: IRecommendedPackageService): TPayPackageService => {
  const { auctionPoints, count, serviceType, price, durationInDays } = service;

  return {
    auctionPoints,
    count,
    icon: getIcon(serviceType),
    marketingPrice: price,
    name: getServiceName(serviceType),
    serviceDurationInDays: durationInDays,
    serviceTypes: [serviceType],
  };
};
